export default __webpack_public_path__ + "static/media/facebook.70a15063.svg";